import { render, staticRenderFns } from "./productExtraImg.vue?vue&type=template&id=d06667e0&"
import script from "./productExtraImg.vue?vue&type=script&lang=js&"
export * from "./productExtraImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports